export default {
  loader: (state) => state.loader.loader,
};
